module.exports = __webpack_public_path__ + "static/media/p6.5cb74458.ogg";